import { getCookie, setCookie } from '@/lib/cookies';

/** À garder aligné avec le script inline dans `index.html`. */
export const LYRRA_CONSENT_STORAGE_KEY = 'lyrra_consent_v1';

/** Nom du cookie décrit sur la page Cookies (politique). */
export const LYRRA_CONSENT_COOKIE_NAME = 'cookieConsent';

export type LyrraConsentChoice = 'all' | 'essential';

export function readStoredConsent(): LyrraConsentChoice | null {
  if (typeof window === 'undefined') return null;
  try {
    const fromLs = localStorage.getItem(LYRRA_CONSENT_STORAGE_KEY);
    if (fromLs === 'all' || fromLs === 'essential') return fromLs;
  } catch {
    /* private mode, etc. */
  }
  const fromCookie = getCookie(LYRRA_CONSENT_COOKIE_NAME);
  if (fromCookie === 'all' || fromCookie === 'essential') return fromCookie;
  return null;
}

export function persistConsent(choice: LyrraConsentChoice): void {
  try {
    localStorage.setItem(LYRRA_CONSENT_STORAGE_KEY, choice);
  } catch {
    /* ignore */
  }
  setCookie(LYRRA_CONSENT_COOKIE_NAME, choice, 365);
}

export function applyGtagConsent(choice: LyrraConsentChoice): void {
  const g = typeof window !== 'undefined' ? window.gtag : undefined;
  if (typeof g !== 'function') return;

  if (choice === 'all') {
    g('consent', 'update', {
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      analytics_storage: 'granted',
      functionality_storage: 'granted',
      personalization_storage: 'granted',
    });
    return;
  }

  g('consent', 'update', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    functionality_storage: 'denied',
    personalization_storage: 'denied',
  });
}
